module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active-user"
  }, [(_vm.showCloseCross) ? _c('div', {
    staticClass: "active-user__close-cross",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "active-user__title"
  }, [_c('div', {
    staticClass: "active-user__title__bttn icon__bg-circle hint--right",
    attrs: {
      "aria-label": _vm.$t('vue2.task_overview.task_and_hour_overview')
    },
    on: {
      "click": _vm.emitShowUserTasks
    }
  }, [_c('svg', {
    staticClass: "icon-chart tw-icon tw-icon--small",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "secondary",
    attrs: {
      "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.allUsersInHash[_vm.activeUserId].name))])]), _vm._v(" "), (_vm.canSeeSubjectRequests && _vm.userSubjectRequests.length > 0) ? _c('button', {
    staticClass: "marg-10-bottom do-bttn do-bttn--small",
    on: {
      "click": _vm.openSubjectRequests
    }
  }, [_vm._v("Se fagønsker (" + _vm._s(_vm.userSubjectRequests.length) + ")")]) : _vm._e(), _vm._v(" "), _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['subjects'],
      "hoursTitle": "UV",
      "id": "teaching",
      "tasks": _vm.getAllUserSubjectsAndTeachingTasks,
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedTeachingHours(_vm.activeUserId),
      "isTeaching": true,
      "isPoolsDeactivated": _vm.isPoolsDeactivated,
      "showLessonsPerWeek": _vm.showLessonsPerWeek
    },
    on: {
      "edit": _vm.setEditSubject,
      "setActiveSubject": _vm.setActiveSubject,
      "setActiveTaskSubject": _vm.setActiveTaskSubject
    }
  }), _vm._v(" "), _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['additional_tasks'],
      "id": "tasks",
      "hoursTitle": "Øvrig",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksTask,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedTaskHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditSubject,
      "setActiveSubject": _vm.setActiveSubject,
      "setActiveTaskSubject": _vm.setActiveTaskSubject
    }
  }), _vm._v(" "), _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['preparation'],
      "id": "preperation",
      "hoursTitle": "Forb.",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksPrep,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedPreparationHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditSubject,
      "setActiveSubject": _vm.setActiveSubject,
      "setActiveTaskSubject": _vm.setActiveTaskSubject
    }
  }), _vm._v(" "), (_vm.getAllUserTasksClub.length > 0) ? _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['club'],
      "id": "club",
      "hoursTitle": "SFO.",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksClub,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedClubHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditSubject,
      "setActiveSubject": _vm.setActiveSubject,
      "setActiveTaskSubject": _vm.setActiveTaskSubject
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSchoolFeatureLocalePool && _vm.getAllUserTasksPool.length > 0) ? _c('TasksTable', {
    attrs: {
      "title": _vm.localPoolTitle,
      "id": "pool",
      "hoursTitle": _vm.localPoolTitle,
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksPool,
      "userCalendarId": _vm.userCalId,
      "assignedHours": _vm.getUserAssignedPoolHours(_vm.activeUserId),
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditSubject,
      "setActiveSubject": _vm.setActiveSubject,
      "setActiveTaskSubject": _vm.setActiveTaskSubject
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getAllUserTasksAvailable.length > 0) ? _c('TasksTable', {
    attrs: {
      "title": _vm.i18n[_vm.locale]['available'],
      "id": "available",
      "hoursTitle": "Råd.",
      "user": _vm.allUsersInHash[_vm.activeUserId],
      "tasks": _vm.getAllUserTasksAvailable,
      "userCalendarId": _vm.userCalId,
      "assignedHours": 0,
      "isPoolsDeactivated": _vm.isPoolsDeactivated
    },
    on: {
      "edit": _vm.setEditSubject,
      "setActiveSubject": _vm.setActiveSubject,
      "setActiveTaskSubject": _vm.setActiveTaskSubject
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "active-user__agreements"
  }, [_c('SubjectsDistributionUserAgreements', {
    attrs: {
      "userId": _vm.activeUserId
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.showSubjectRequests) ? _c('DModal', {
    on: {
      "close": function($event) {
        _vm.showSubjectRequests = false
      }
    }
  }, [_c('div', {
    staticClass: "subject-requests-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('h3', {
    staticClass: "subject-requests-modal__title"
  }, [_vm._v("Fagønsker for " + _vm._s(_vm.allUsersInHash[_vm.activeUserId].name))]), _vm._v(" "), (_vm.isLoadingSubjectRequests) ? _c('div', {
    staticClass: "subject-requests-modal__loading"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : [(_vm.userSubjectRequests.length > 0) ? _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Fag")]), _vm._v(" "), _c('th', [_vm._v("Klasse")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("Timer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userSubjectRequests), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', [_c('div', {
      staticClass: "subjects_subject",
      style: ({
        'background-color': subject.color
      })
    }, [_vm._v("\n                    " + _vm._s(subject.name) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subject.vKlass))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(subject.vHours))])])
  }), 0)]) : _c('p', {
    staticClass: "subject-requests-modal__empty"
  }, [_vm._v("Ingen fagønsker registreret")])]], 2)]) : _vm._e()], 1), _vm._v(" "), (_vm.showSubjectRequests) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": function($event) {
        _vm.showSubjectRequests = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-modal"
    }
  }, [(_vm.theActiveSubject && _vm.getTheActiveSubject) ? _c('DModal', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "showClose": false
    },
    on: {
      "close": _vm.closeActiveSubject
    }
  }, [_c('SubjectsDistributionUserEditHours', {
    attrs: {
      "slot": "insertComponent",
      "subject": _vm.getTheActiveSubject,
      "teacher": _vm.getTheActiveUser,
      "task": _vm.theActiveTask
    },
    on: {
      "close": _vm.closeActiveSubject
    },
    slot: "insertComponent"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.theActiveSubject && _vm.getTheActiveSubject) ? _c('div', {
    staticClass: "bg-overlay",
    on: {
      "click": _vm.closeActiveSubject
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25fd8e5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionUser.vue
// module id = 1813
// module chunks = 1